import React, { useEffect, useState } from 'react';
import { FileOptionProps, FileData } from './types';
import { IconWrapper, TextWrapper, Wrapper } from './file-option.styles';
import { Typography } from '@shared/ui/typography/typography';
import { fileFormatBytes } from '@shared/lib/utils/file-format-bytes/file-format-bytes';
import { FileIcon } from '@shared/ui/file-icon/file-icon';
import { IMAGE_EXTENSIONS } from '@shared/config/file/image-extensions';

export const FileOption: React.FC<FileOptionProps> = ({ file, disabled }) => {
    const [fileData, setFileData] = useState<FileData | null>(null);

    useEffect(() => {
        const extension = file.meta.extension;
        const isImage = extension && IMAGE_EXTENSIONS.includes(extension);
        setFileData({
            imageUrl: isImage ? file.url : undefined,
            name: file.name,
            size: fileFormatBytes(file.meta.size),
            extension: extension || '',
        });
    }, []);

    if (!fileData) {
        return null;
    }

    return (
        <Wrapper disabled={disabled}>
            <IconWrapper>
                <FileIcon dimension='l' file={fileData} />
            </IconWrapper>
            <TextWrapper>
                <Typography size='body2_long'>
                    {fileData.name}.{fileData.extension}
                </Typography>
                <Typography size='caption1' color='neutral_50'>
                    {fileData.size}
                </Typography>
            </TextWrapper>
        </Wrapper>
    );
};
